import { PageContainerComponent as PageContainer } from "./pageContainer.component";
export default PageContainer;
